export const formatPhoneNumber = mdn => {
  const stringifyMdn = typeof mdn === "string" ? mdn : JSON.stringify(mdn);
  const newMdn = stringifyMdn ? stringifyMdn.split("") : [];

  if (newMdn.length === 10) {
    newMdn.splice(3, 0, ".");
    newMdn.splice(7, 0, ".");
  } else if (newMdn.length === 11) {
    newMdn.splice(1, 0, ".");
    newMdn.splice(5, 0, ".");
    newMdn.splice(9, 0, ".");
  }

  return newMdn.join("");
};
